// **src/index.tsx** (for reference)
import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/tokens.css';
import './theme/animations.css';
import './index.css';
import './theme/legacy-skin.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
